module.exports = __webpack_public_path__ + "media/images/flags/32/Cyprus-34894ffc006581be3ef33102fc589c4e.png";